/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./addressPicker.vue?vue&type=template&id=dea57a1a&scoped=true"
import script from "./addressPicker.vue?vue&type=script&lang=js"
export * from "./addressPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea57a1a",
  null
  
)

export default component.exports